

















































































import {
	computed,
	defineComponent,
	PropType,
	Ref,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { ShareContentPanelState, routeToShareContent } from '@front-app/modules/group/util/shareContentModal';
import { Group, GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { useCommunityColors } from '@front-app/modules/community/hooks/useCommunityColors';
import { Routes } from '@front-app/constants/routes';
import { GroupPageTab } from '@front-app/views/home/groups/GroupEnum';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { canCreateGroupEvents } from '@front-app/util/permission';
import { CurrentUserStore } from '@front-app/store/singletons/User';

const TAB_KEY_TO_LABEL: Record<GroupPageTab, (group: Group | undefined) => string> = {
	[GroupPageTab.MAIN]: () => 'group.tabs.main',
	[GroupPageTab.CONTENT]: () => 'group.tabs.content',
	[GroupPageTab.EVENTS]: () => 'group.tabs.events',
	[GroupPageTab.CUSTOM]: (group) => (group?.pageName || 'group.tabs.custom'),
	[GroupPageTab.LMS]: () => 'group.tabs.learning',
};

const TAB_KEY_TO_ROUTE_NAME: Record<GroupPageTab, Routes> = {
	[GroupPageTab.MAIN]: Routes.GROUP_MAIN,
	[GroupPageTab.CONTENT]: Routes.GROUP_CONTENT,
	[GroupPageTab.EVENTS]: Routes.GROUP_EVENTS,
	[GroupPageTab.CUSTOM]: Routes.GROUP_CUSTOM,
	[GroupPageTab.LMS]: Routes.GROUP_LEARNING,
};

export default defineComponent({
	components: {
		TabbedNav,
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
		visibleTabs: {
			type: Array as PropType<GroupPageTab[]>,
			required: true,
		},
		currentTabKey: {
			type: String as PropType<GroupPageTab | null>,
			required: false,
			default: null,
		},
		canSeeStartDiscussionCta: Boolean,
		canShareFilesToGroup: Boolean,
	},
	setup(props, ctx) {
		const groupTabButtons: Ref<ButtonNavButton[]> = computed(() => props.visibleTabs.map((tab) => ({
			key: tab.toString(),
			label: TAB_KEY_TO_LABEL[tab](props.group),
			to: { name: TAB_KEY_TO_ROUTE_NAME[tab], params: { groupId: props.group.id } },
		})));

		// Community
		const {
			headerNavStyles,
		} = useCommunityColors(computed(() => props.group.community?.customColorPalette));

		// Events
		const canSeeCreateEventCta = computed(() => canCreateGroupEvents(CurrentUserStore.isCsr.value, props.group));

		const toShareContent = computed(() => routeToShareContent(ctx, ShareContentPanelState.FILE));

		return {
			canSeeCreateEventCta,
			groupTabButtons,
			toShareContent,
			headerNavStyles,
			ButtonPalettes,
		};
	},
});
